module.exports = __webpack_public_path__ + "img/p_sz_24.c24e1fb5.png";